import styles from './BackgroundBanner.module.scss'

export const BackgroundBanner = ({ banner }: any) => <div className={styles['banner']} style={{ backgroundImage: `url(${banner})` }} />
